class Breakpoint
{
	public Min: number;
	public Max?: number;

	constructor(min: number, max?: number)
	{
		this.Min = min;

		if (typeof max !== "undefined")
		{
			this.Max = max - 0.2;
		}
	}

	public get IsDown(): boolean
	{
		if (typeof this.Max !== "undefined")
		{
			return window.matchMedia(`(max-width: ${this.Max}px)`).matches;
		}
		else
		{
			return false;
		}
	}

	public get IsMatch(): boolean
	{
		return window.matchMedia(`(min-width: ${this.Min}px) and (max-width: ${this.Max}px)`).matches;
	}

	public get IsUp(): boolean
	{
		return window.matchMedia(`(min-width: ${this.Min}px)`).matches;
	}
}

export class Media
{
	private static MinPoints = {
		Xs: 0,
		Sm: 576,
		Md: 768,
		Lg: 992,
		Xl: 1200,
		Xxl: 1500
	};

	public static Breakpoints = {
		Xs: new Breakpoint(Media.MinPoints.Xs, Media.MinPoints.Sm),
		Sm: new Breakpoint(Media.MinPoints.Sm, Media.MinPoints.Md),
		Md: new Breakpoint(Media.MinPoints.Md, Media.MinPoints.Lg),
		Lg: new Breakpoint(Media.MinPoints.Lg, Media.MinPoints.Xl),
		Xl: new Breakpoint(Media.MinPoints.Xl, Media.MinPoints.Xxl),
		Xxl: new Breakpoint(Media.MinPoints.Xxl)
	};

	public static MediaMobile = `(max-width: ${Media.Breakpoints.Md.Max}px)`;

	public static MediaDesktop = `(min-width: ${Media.Breakpoints.Lg.Min}px)`;

	public static get DeviceType(): string
	{
		if (this.Breakpoints.Lg.IsDown)
		{
			return "mobile";
		}
		else
		{
			return "desktop";
		}
	}
}

// interface IBreakpoint
// {
// 	Min: number,
// 	Max: number,
// 	Matches: boolean
// }

// export class Breakpoint
// {
// 	public static Xs: IBreakpoint = {
// 		Min: 0,
// 		Max: 575.98,
// 		Matches: this.IsMatch(this.Xs)
// 	};

// 	public static Sm: IBreakpoint = {
// 		Min: 576,
// 		Max: 767.98
// 	};

// 	public static Md: IBreakpoint = {
// 		Min: 768,
// 		Max: 991.98
// 	};

// 	public static Lg: IBreakpoint = {
// 		Min: 992,
// 		Max: 1199.98
// 	};

// 	public static Xl: IBreakpoint = {
// 		Min: 1200,
// 		Max: 1499.98
// 	};

// 	public static Xxl: IBreakpoint = {
// 		Min: 1500,
// 		Max: 0
// 	}

// 	public static MediaMobile = "(max-width: 991.98px)";
// 	public static MediaDesktop = "(min-width: 992px)";

// 	public static IsDesktop(): boolean
// 	{
// 		return this.brea
// 	}

// 	public static IsDown(breakpoint: IBreakpoint): boolean
// 	{
// 		if (breakpoint.Max === 0)
// 		{
// 			return true;
// 		}
// 		else
// 		{
// 			return window.matchMedia(`(max-width: ${breakpoint.Max})`).matches;
// 		}
// 	}

// 	public static IsMatch(breakpoint: IBreakpoint): boolean
// 	{
// 		let query;

// 		if (breakpoint.Min === 0)
// 		{
// 			query = `(max-width: ${breakpoint.Max})`;
// 		}
// 		if (breakpoint.Max === 0)
// 		{
// 			query = `(min-width: ${breakpoint.Min})`;
// 		}
// 		else
// 		{
// 			query = `(min-width: ${breakpoint.Min}) and (max-width: ${breakpoint.Max})`;
// 		}

// 		return window.matchMedia(query).matches;
// 	}

// 	public static IsUp(breakpoint: IBreakpoint): boolean
// 	{
// 		if (breakpoint.Min === 0)
// 		{
// 			return true;
// 		}
// 		else
// 		{
// 			return window.matchMedia(`(min-width: ${breakpoint.Min})`).matches;
// 		}
// 	}

// 	public static get Media()
// 	{
// 		if (this.IsMatch(Breakpoint.Breakpoints.Lg))
// 		{
// 			return "desktop";
// 		}
// 		else
// 		{
// 			return "mobile;"
// 		}
// 	}
// 	// var MediaMd = "(min-width: 768px)";
// 	// var MediaLg = "(min-width: 992px)";
// 	// var MediaXl = "(min-width: 1200px)";
// 	// var MediaXxl = "(min-width: 1400px)";
// 	// var MediaMobile = "(max-width: 991px)";
// 	// var MediaDesktop = MediaLg;
// 	// var Media = "desktop";

// 	public IsXs(): boolean
// 	{
// 		return this.GetBreakpoint('xs');
// 	}

// 	public IsSm(): boolean
// 	{
// 		return this.GetBreakpoint('sm');
// 	}

// 	public IsMd(): boolean
// 	{
// 		return this.GetBreakpoint('md');
// 	}

// 	public IsLg(): boolean
// 	{
// 		return this.GetBreakpoint('lg');
// 	}

// 	public IsXl(): boolean
// 	{
// 		return this.GetBreakpoint('xl');
// 	}

// 	public IsSmDown(): boolean
// 	{
// 		return this.GetBreakpoint('smDown');
// 	}

// 	public IsMdDown(): boolean
// 	{
// 		return this.GetBreakpoint('mdDown');
// 	}

// 	public IsLgDown(): boolean
// 	{
// 		return this.GetBreakpoint('lgDown');
// 	}

// 	public IsSmUp(): boolean
// 	{
// 		return this.GetBreakpoint('smUp');
// 	}

// 	public IsMdUp(): boolean
// 	{
// 		return this.GetBreakpoint('mdUp');
// 	}

// 	public IsLgUp(): boolean
// 	{
// 		return this.GetBreakpoint('lgUp');
// 	}

// 	private GetBreakpoint(value: string): boolean
// 	{
// 		var el, check, cls;

// 		switch (value)
// 		{
// 			case 'xs':
// 				cls = 'd-none d-sm-block';
// 				break;
// 			case 'sm':
// 				cls = 'd-block d-sm-none d-md-block';
// 				break;
// 			case 'md':
// 				cls = 'd-block d-md-none d-lg-block';
// 				break;
// 			case 'lg':
// 				cls = 'd-block d-lg-none d-xl-block';
// 				break;
// 			case 'xl':
// 				cls = 'd-block d-xl-none';
// 				break;
// 			case 'smDown':
// 				cls = 'd-none d-md-block';
// 				break;
// 			case 'mdDown':
// 				cls = 'd-none d-lg-block';
// 				break;
// 			case 'lgDown':
// 				cls = 'd-none d-xl-block';
// 				break;
// 			case 'smUp':
// 				cls = 'd-block d-sm-none';
// 				break;
// 			case 'mdUp':
// 				cls = 'd-block d-md-none';
// 				break;
// 			case 'lgUp':
// 				cls = 'd-block d-lg-none';
// 				break;
// 		}

// 		// el = $('<div/>', {
// 		// 	'class': cls
// 		// }).appendTo('body');

// 		// check = el.is(':hidden');
// 		// el.remove();

// 		return check;
// 	}
// }